import {User} from '@plasma/ui.application.app-provider';

const headers_custom_func_get = () => {
  const username = sessionStorage.getItem('username');
  const token = sessionStorage.getItem('token');
  const company = sessionStorage.getItem('company');
  const companyId = sessionStorage.getItem('companyID');
  const Headers_custom = new Headers();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  Headers_custom.append("Content-Type", "application/json");
  Headers_custom.append("username", username);
  Headers_custom.append("token", token);
  Headers_custom.append('company', company);
  Headers_custom.append('timezone', userTimeZone);
  Headers_custom.append('TargetProjectId', companyId);
  return Headers_custom;
}

const headers_custom_func_get_for_RFQ = () => {
  const username = sessionStorage.getItem('username');
  const token = sessionStorage.getItem('token');
  const company = sessionStorage.getItem('company');
  const companyId = sessionStorage.getItem('companyID');
  const Headers_custom = new Headers();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  Headers_custom.append("Content-Type", "application/pdf;base64");
  Headers_custom.append("username", username);
  Headers_custom.append("token", token);
  Headers_custom.append('company', company);
  Headers_custom.append('timezone', userTimeZone);
  Headers_custom.append('TargetProjectId', companyId);
  return Headers_custom;
}

const headers_guidFile_func_get = () => {
  const username = sessionStorage.getItem('username');
  const token = sessionStorage.getItem('token');
  const company = sessionStorage.getItem('company');
  const companyId = sessionStorage.getItem('companyID');
  const Headers_custom = new Headers();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  Headers_custom.append("Content-Type", "application/pdf;base64");
  Headers_custom.append("username", username);
  Headers_custom.append("token", token);
  Headers_custom.append('company', company);
  Headers_custom.append('timezone', userTimeZone);
  Headers_custom.append('TargetProjectId', companyId);
  return Headers_custom;
}

 const headers_file_func_get = () => {
  const username = sessionStorage.getItem('username');
  const token = sessionStorage.getItem('token');
  const company = sessionStorage.getItem('company');
  const companyId = sessionStorage.getItem('companyID');
  const Headers_custom = new Headers();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  Headers_custom.append("username", username);
  Headers_custom.append("token", token);
  Headers_custom.append('company', company);
  Headers_custom.append('timezone', userTimeZone);
  Headers_custom.append('TargetProjectId', companyId);
  return Headers_custom;
}

const headers_custom_func_set = (userInfo: UserInfoKeyCloak) => {
  sessionStorage.setItem('loggedIn', 'true');
  sessionStorage.setItem('username', userInfo.preferred_username);
  sessionStorage.setItem('company', userInfo.email.split('@')[1].split('.')[0]);
  sessionStorage.setItem('token', userInfo.sub);
  sessionStorage.setItem('roleid', userInfo.roleid);
}

const headers_custom_func_set_logoff = () =>{
  sessionStorage.removeItem('loggedIn');
  sessionStorage.removeItem('username');
  sessionStorage.removeItem('company');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('roleid');
  sessionStorage.removeItem('companyID');
}

const setUserFunction = (user: User) => {
  sessionStorage.setItem('AuthenticUsers',JSON.stringify(user));
}
const getUserFunction = () => {
  return  JSON.parse( sessionStorage.getItem('AuthenticUsers'));
}

export {
  headers_custom_func_set,
  headers_custom_func_get,
  headers_custom_func_get_for_RFQ,
  headers_custom_func_set_logoff,
  headers_file_func_get,
  headers_guidFile_func_get,
  setUserFunction,
  getUserFunction
};
